<template>
  <tile class="opc-zmone">
    <foldable v-if="showFoldable" v-model="isExpanded" :title="title" :arrow="showFoldableArrow" :edit="canExpand" :isRemoveWrapAriaLabelledby="true">
      <template #head>
        <div>
          <zm-banner show-close v-if="alertTitle" class="opc-common-info-alert" :content="alertTitle" type="info"
            show-icon />
          <div class="opc-zm-base-card__head">
            <div class="opc-zm-base-card__head-left">
              <img
                :class="['opc-zm-base-card__logo']"
                :src="isEducationMeeting?logoEdu:logo"
                :alt="title"
              />
            </div>
            <div :class="[
              'opc-zm-base-card__head-right',
              ...headClassForSchool,
            ]">
              <div class="opc-zm-base-card__head-right-content">
                <h2 :class="[
                  'opc-zm-base-card__name',
                  isSchool ? '' : 'text-capitalize',
                ]">
                  {{ title }}
                  <!-- <i class="zm-icon-success main-icon" aria-hidden="true" v-if="!mxIsSimplifyForProEdit"></i> -->
                </h2>
                <div :class="['opc-zm-base-card__view-detail-button']">
                  <template v-if="isExpanded">
                    <zm-button data-testid="checkout-button-139" class="opc-zm-base-card__link" type="link" @click="handlePlanDetailsClick" v-if="isEducationMeeting && !msqEditMode">
                      {{$config('enableEduAnnualUpgrade')? $t('billing.zone.explore_other_plans_edit'): $t('billing.plan_details') }}
                    </zm-button>
                    <zm-button data-testid="checkout-button-140" class="opc-zmone__link" type="link" @click="handleExploreOtherPlansClick" v-else>
                      {{ $t('billing.zone.explore_other_plans_edit') }}
                    </zm-button>
                  </template>
                </div>
              </div>
              <div class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" v-if="!isExpanded && formPlan" v-html="getPlanCollapseText()"></div>
          </div>
        </div>
        </div>
      </template>
      <div class="opc-zmone__main">
        <multiple-meeting-single-edit-form v-if="msqEditMode" :ctx="ctx" />
        <zm-form ref="zmoneForm" label-position="top" class="opc-config-form" v-else @submit.prevent>
          <zm-form-item class="opc-zmone__form-item--license">
            <p class="opc-zmone__form-label">
              {{ mxIsSimplifyForProEdit ? $t('billing.simplify.select_license') : $t('billing.zone.select_license') }}
              <zm-tooltip class="item" disallow-learn-about aria-label="Learn more about Select the number of users" placement="top">
                <template #content>
                  <span class="opc-zone__tip" v-html="$t('billing.zone.attendee_info_edit')"></span>
                </template>
                <tips-icon aria-label="select the number of users" @click="handleSelectNumOfUsersTipsClick" />
              </zm-tooltip>
              <bought-license v-if="mxIsSimplifyForProEdit" :type="planTypes.ZOOM_MEETING" />
            </p>
            <div class="opc-zmone__quantity-selector-container">
              <InputNumberWithPopover class="opc-zmone__quantity-selector" v-model="form.selectedNumber" size="lg"
                controls-position="both" :min="minHost" :max="maxHost" @change="submitForm"
                :label="`${title} Select the number of users`" :decrease-tips="popUpDecreaseTips" :increase-tips="increaseTips"
                :data-testid="`checkout-input-license-${formPlan ? formPlan.plan_code : ''}`" />
              <user-changes v-if="mxIsSimplifyForProEdit" :type="planTypes.ZOOM_MEETING" :value="form.selectedNumber" />
            </div>
            <div v-if="!mxIsSimplifyForProEdit">
              <div class="opc-plan__bought-license" v-if="showUnlockBizCountTip">{{$t('billing.zoom_one_biz.unlock_license_limit')}}</div>
              <bought-license v-else :type="planTypes.ZOOM_MEETING"/>
            </div>
          </zm-form-item>
          <zm-banner show-close class="reason-tips" v-if="licenseTips" type="info" style="margin-bottom: 16px;">
            <p @click='onLicenseTipsClick' v-html="licenseTips"></p>
          </zm-banner>
          <zm-form-item :class="[...classForSimplifySubscriptionCycle]" :label="mxIsSimplifyForProEdit ? $t('billing.simplify.subscription_cycle') : $t('billing.select_billing_cycle')">
            <template #label-suffix>
              <div v-if="mxIsSimplifyForProEdit" class="opc-plan__billing-text">
                {{ getCurrentBilledText() }}
              </div>
            </template>
            <zm-radio-group
              v-model="form.billingCycle"
              :class="['opc-card-radio']"
              :aria-label="`${title} Billing Cycle`"
              @change="submitForm"
            >
              <zm-radio v-for="plan in currentFilterPlans" :data-testid="`checkout-radio-billing-cycle-${plan.plan_code}`" :key="plan.billing_cycle" :label="plan.billing_cycle"
                :disabled="billingCycleDisabled(plan)" class="opc-zmone__radio" :class="[!mxIsSimplifyForProEdit ? 'compact' : '']">
                <p class="opc-zmone__radio-title">
                  <span>{{ getBillingCycleText(plan.billing_cycle) }}</span>
                  <CycleCurrentBadge :value="plan" v-if="!showAnnualTermMonthly || mxIsSimplifyForProEdit"/>
                  <save-count
                    v-if="showSaveCount(plan)"
                    :disabled="billingCycleDisabled(plan)"
                    :annual-price="annuallyPrice"
                    :monthly-price="monthlyPrice"
                    :class="[mxIsSimplifyForProEdit ? 'light' : '']"
                  />
                </p>
                <subscription-cycle-sub-title :billingCycle="plan.billing_cycle" :currentCategory="form.category" :showLinkMark="showAnnualTermMonthly" v-if="showAnnualTermMonthly"/>
                <p class="opc-product-price-container" tabindex="-1" :aria-label="ariaPriceOfMonthForLabel(plan)" v-if="!mxIsSimplifyForProEdit">
                  <span class="opc-product-price-container__price" aria-hidden="true">
                    {{ getFormattedPriceOfMonth(plan, { forceDiff: true }) }}
                  </span>
                </p>
                <p class="opc-zmone__radio-price-unit opc-price-bill-text">
                  <span v-html="getBilledText(plan)"></span><priceVATTip />
                </p>
                <CycleCurrentBadge :value="plan" v-if="showAnnualTermMonthly && !mxIsSimplifyForProEdit" standalone />
              </zm-radio>
            </zm-radio-group>
          </zm-form-item>
          <PriceBillTextTips v-if="showAnnualTermMonthly" />
          <zm-banner class="reason-tips"
            v-if="form.billingCycle !== cycleDisabledKeyAndReason.key && cycleDisabledKeyAndReason.reason" type="info"
            :show-close="false">
            <p @click="onCycleClick" v-html="cycleDisabledKeyAndReason.reason"></p>
          </zm-banner>
          <preview-payment />
        </zm-form>
        <p class="bottom-msg-row" v-if="showAddAnotherMeetingPlanButton" v-html="$t('billing.add_another_workplace_plan', [addAnotherMeetingLink, addAnotherMeetingPlanLink])"></p>
      </div>
    </foldable>
  </tile>
</template>
<script>
import Foldable from '@/components/foldable.vue';
import Tile from '@/components/tile.vue';
import SaveCount from '@/components/save-count.vue';
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
import UserChanges from '@/components/users-change.vue';
import PriceBillTextTips from '@/plans/ZOOM_MEETING/components/price-bill-text-tips.vue';
import logo from '@/assets/plans/icon_ZM.svg';
import logoEdu from '@/assets/plans/video_sdk.svg'
import {
  A_LINK_TAG_NAME,
  A_LINK_TEXT_CONTENT,
  BILLING_CYCLE, EDIT_FLOW_TRACKING_TYPE,
  limitBillingCycleWithBaseZoneTypes,
  planTypes,
  BASE_PLAN_SUB_TYPES,
  ZOOM_MEETING_PRO_MIN_LICENSE, BillingCycleEnum, AUDIO_SUB_TYPES,
  unlockBizLicenseCount,
  DEFAULT_MAX_HOST,
  OPC_HREF_SYNC_QUERY_PARAMS,
  MODAL_QUERY_PARAMS,
} from '@/common/constants';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import _, { debounce, get, groupBy, throttle } from 'lodash';
import { getMeetingPlanByCategory, getCategoryNameI18nKey } from '@/plans/ZOOM_MEETING/common/utils';
import plansMixin from '@/plans/mx/plan';
import simplifyForProMixin from '@/plans/ZOOM_MEETING/mixin/simplify-for-pro.js';
import { isEmptyVal, updateHrefWithQueryParams } from '@/utils';
import { ZOOM_MEETING_SUB_TYPES, isInUnlockBizCountRetentionFlow } from '../common/utils';
import { ONLINE_NOT_SUPPORT_BILLING_CYCLE } from '@/common/service/non-standard-billing-cycle-utils';
import saveMixins from '../save-mixins';
import { getPlanUnitWithCycle } from '@/common/product-unit';
import { validDownSellLicense } from '@/utils/validate-downsell';
import audioUsCaMixin from '@/common/mixin/audio-us-ca-mixin';
import PreviewPayment from '@/views/checkout/payment/preview-payment';
import { editBasePlanWithPartnerMixin } from "@/views/config/partner-refer/mixin/edit-plan-with-partner";
import discountedMonthPrice from '@/common/mixin/discounted-month-price';
import ZoomMeetingDialogUtils from '../dialog/utils';
import BoughtLicense from '@/views/config/shopping-cart/prorated/bought-license.vue';
import { translateToEn } from '@/plugins/i18n'
import promoModifyMixin from '@/common/mixin/promo-modify-mixin';
import CycleCurrentBadge from '@/components/service/config-billing-cycle/cycle-current-badge.vue';
import { $info } from '@/components/service/config-banner';
import { enableProAnnualMonthlyPaymentPlanP2, enableProAnnualWithMonthlyPaymentPre } from '@/common/constants';
import SubscriptionCycleSubTitle from '@/plans/ZOOM_MEETING/components/subscription-cycle-sub-title.vue';
import { proAnnualMonthlyMarketingCampaignLimited } from '@/utils/annual-term-monthly-utils';
import { sortPlansByCycleValue, getPlanCollapseText } from '@/common/product';
import MultipleMeetingSingleEditForm from '@/plans/ZOOM_MEETING/components/multiple-meeting-single-edit-form.vue';

export default {
  name: 'ZoomMeetingEdit',
  mixins: [
    plansMixin,
    saveMixins,
    audioUsCaMixin,
    editBasePlanWithPartnerMixin,
    discountedMonthPrice,
    promoModifyMixin,
    simplifyForProMixin,
  ],
  data() {
    return {
      logo,
      logoEdu,
      isExpanded: true,
      form: {
        category: 'pro',
        billingCycle: 'annual',
        selectedNumber: 1,
      },
      oldPlanCode: '',
      BILLING_CYCLE: BILLING_CYCLE,
      isInitUpdateForm: false,
      canExpand: true,
      showFoldable: true,
      planTypes,
      alertTitle: ''
    };
  },
  computed: {
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
      boughtPlans: state => state.ShoppingCart.boughtPlans,
      assignInfo: state => state.ShoppingCart.assignInfo,
      updateBasePlan: state => state.Product.updateBasePlan,
    }),
    ...mapGetters([
      'getSelectedPlans',
      'getUserCurrentSubscriptions',
      'basicConfig',
      'disableMonthly2AnnualTip',
      'isMultipleCoupon',
      'getCurrentBasePlanInfo',
      'plansofBizBundle',
      'limitLicenseWithBaseZoneTypes',
      'partnerRefer',
      'migratePlanState',
      'boughtPlansGroupByCategoryCode',
      'boughtPlans',
      'freeTrialPlans',
      'getBoughtBasePlanInfo',
      'assignInfo',
      'currentEditPlan',
      'msqFeatureEnabled',
      'multipleSubscriptionScope',
    ]),
    ...mapGetters({
      currentEditOldPlanCode: 'oldPlanCode',
    }),
    addAnotherMeetingLink() {
      if (this.$context.is.modal) {
        const link = `/opc/buy/add?type=add&subPlan=newsubs&from=${this.form.category}&pageType=modal${this.$context?.is?.simplify ? '&fromSimplifyPage=true' : ''}`;
        return updateHrefWithQueryParams(link, OPC_HREF_SYNC_QUERY_PARAMS);
      }
      return `/opc/buy/add?type=add&subPlan=newsubs&from=${this.form.category}`;
    },
    supportMSQ() {
      return this.multipleSubscriptionScope.some(scope => (
        scope.type === planTypes.ZOOM_MEETING && scope.category === this.form.category
      ));
    },
    boughtMeetingPlans() {
      return this.boughtPlans.filter(item => item.type === planTypes.ZOOM_MEETING);
    },
    canAddCycles() {
      const cycles = this.boughtMeetingPlans.map(item => item.billing_cycle);
      const supportCycles = [BILLING_CYCLE.MONTHLY, BILLING_CYCLE.ANNUAL];
      const hasUnsupportedCycle = cycles.some(cycle => !supportCycles.includes(cycle));
      if (hasUnsupportedCycle) return [];
      return supportCycles.filter(cycle => !cycles.includes(cycle));
    },
    addAnotherMeetingPlanLink() {
      const [cycle] = this.canAddCycles;
      if (cycle === BILLING_CYCLE.MONTHLY) return this.$t('billing.add_monthly_plan_link');
      if (cycle === BILLING_CYCLE.ANNUAL) return this.$t('billing.add_annual_plan_link');
      return '';
    },
    msqEditMode() {
      return this.basicConfig.multiSubscriptionEnabled && this.boughtMeetingPlans.length > 1;
    },
    showAddAnotherMeetingPlanButton() {
      return (
        this.canAddCycles.length > 0 &&
        !this.migratePlanState?.is?.pro2biz &&
        !this.migratePlanState?.is?.biz2pro &&
        this.msqFeatureEnabled &&
        this.supportMSQ
      );
    },
    cyclePriceText() {
      const plan = this.currentFilterPlans[0]
      return this.getMergedBilledText(plan.billing_cycle, plan.amount);
    },
    ctx() {
      return {
        minHost: this.minHost,
        maxHost: this.maxHost,
        decreaseTips: this.decreaseTips,
        increaseTips: this.increaseTips,
        title: this.title,
        currentPlans: this.currentPlans,
        currentFilterPlans: this.currentFilterPlans,
        showAnnualTermMonthly: this.showAnnualTermMonthly,
        supportMSQ: this.supportMSQ,
        popUpDecreaseTips: this.popUpDecreaseTips,
        classForSimplifySubscriptionCycle: this.classForSimplifySubscriptionCycle,
        mxIsSimplifyForProEdit: this.mxIsSimplifyForProEdit,
        annuallyPrice: this.annuallyPrice,
        monthlyPrice: this.monthlyPrice,
        licenseTips: this.licenseTips,

        mxCheckCollapseSimplifyView: this.mxCheckCollapseSimplifyView.bind(this),
        billingCycleDisabled: this.billingCycleDisabled.bind(this),
        ariaPriceOfMonthForLabel: this.ariaPriceOfMonthForLabel.bind(this),
        getFormattedPriceOfMonth: this.getFormattedPriceOfMonth.bind(this),
        getMergedBilledText: this.getMergedBilledText.bind(this),
        handleSelectNumOfUsersTipsClick: this.handleSelectNumOfUsersTipsClick.bind(this),
        useSmallSize: this.useSmallSize.bind(this),
        getBillingCycleText: this.getBillingCycleText.bind(this),
        getBilledText: this.getBilledText.bind(this),
        showSaveCount: this.showSaveCount.bind(this),
        onLicenseTipsClick: this.onLicenseTipsClick.bind(this),

        __configRef: this,
      }
    },
    boughtBaseCategory() {
      const { plans = [] } = this.getBoughtBasePlanInfo;
      return get(plans, '0.zoomMeetingCategory', '');
    },
    showFoldableArrow() {
      return this.canExpand && !this.mxIsSimplifyForProEdit;
    },
    title() {
      return this.$t(this.formPlan?.planNameKey)
    },
    zonePlans() {
      return this.planMapFlat.filter((item) => item.type === planTypes.ZOOM_MEETING);
    },
    zonePlanGroupByCategory() {
      return groupBy(this.zonePlans, 'category');
    },
    currentPlansHasAnnualTermMonthly() {
      return this.currentPlans.some((item) => item.billing_cycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY);
    },
    showAnnualTermMonthly() {
      return (
        (enableProAnnualWithMonthlyPaymentPre ||
          enableProAnnualMonthlyPaymentPlanP2) &&
        this.currentPlansHasAnnualTermMonthly &&
        !this.hideAnnualTermMonthlyForCurrentEditPlan &&
        !this.basicConfig.multiSubscriptionEnabled
      );
    },
    hideAnnualTermMonthlyForCurrentEditPlan() {
      // * hide pro annual term monthly for biz and standard pro annual(yearly_c50) plan
      return proAnnualMonthlyMarketingCampaignLimited() ||
        (!enableProAnnualMonthlyPaymentPlanP2 && this.currentEditPlanIsBiz) ||
        (!enableProAnnualMonthlyPaymentPlanP2 && this.currentEditPlanIsStandardProAnnual);
    },
    currentEditPlanIsStandardProAnnual() {
      const standardProAnnualPlancode = 'yearly_c50';
      return this.currentEditPlan?.plan_code === standardProAnnualPlancode && this.getSelectedPlans[0]?.plan_code === standardProAnnualPlancode;
    },
    currentEditPlanIsBiz() {
      return this.currentEditPlan?.category === BASE_PLAN_SUB_TYPES.BIZ;
    },
    currentFilterPlans() {
      // Filter plans if needed
      const otherBoughtMeetingPlansFilter = item => !this.boughtMeetingPlans.some(boughtPlan => (
        boughtPlan.billing_cycle === item.billing_cycle &&
        boughtPlan.plan_code !== this.currentEditOldPlanCode
      ))
      if (!this.showAnnualTermMonthly && this.currentPlansHasAnnualTermMonthly) {
        return sortPlansByCycleValue(this.currentPlans.filter((item) => item.billing_cycle !== BILLING_CYCLE.ANNUAL_TERM_MONTHLY)).filter(otherBoughtMeetingPlansFilter);
      }

      return sortPlansByCycleValue(this.currentPlans).filter(otherBoughtMeetingPlansFilter);
    },
    currentPlans() {
      return this.zonePlanGroupByCategory[this.form.category];
    },
    isEducationMeeting() {
      return this.form.category === BASE_PLAN_SUB_TYPES.EDUCATION
    },
    annualPriceM() {
      const monthPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.MONTHLY);
      return monthPlan ? monthPlan.amount * 12 : 0;
    },
    monthlyPrice() {
      const monthPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.MONTHLY);
      return monthPlan ? monthPlan.amount : 0;
    },
    annuallyPrice() {
      const annualPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.ANNUAL);
      return annualPlan ? annualPlan.amount : 0;
    },
    annalPriceSave() {
      const annualPlan = this.currentPlans.find((item) => item.billing_cycle === BILLING_CYCLE.ANNUAL);
      if (this.annualPriceM && annualPlan) {
        return this.annualPriceM - annualPlan.amount;
      }
      return 0;
    },
    saveLabel() {
      return {
        [BILLING_CYCLE.MONTHLY]: '',
        [BILLING_CYCLE.ANNUAL]: this.annalPriceSave > 0
          ? `${this.$money(this.annalPriceSave)} ${this.$t('billing.annual_save')}`
          : '',
      };
    },
    // current selected meeting plan
    formPlan() {
      return this.zonePlanGroupByCategory[this.form.category].find(
        (item) => item.billing_cycle === this.form.billingCycle,
      );
    },
    totalCoast() {
      if (this.formPlan) {
        return this.formPlan.amount * this.form.selectedNumber;
      }
      return 0;
    },
    limitCycleAddonPlans() {
      const disableCycle = this.currentPlans.find((p) => p.cycleValue < this.boughtMeetingPlan.cycleValue)?.cycleValue;
      if (!disableCycle) {
        return [];
      }

      const newLimit = [];
      return this.getUserCurrentSubscriptions.filter(item => (
        limitBillingCycleWithBaseZoneTypes.concat(newLimit).includes(item.type) &&
        item.cycleValue > disableCycle
      ));
    },
    maxLicenseAddon() {
      return this.getUserCurrentSubscriptions
        .filter(item => _.includes(this.limitLicenseWithBaseZoneTypes, item.type))
        .reduce((maxPlan, plan) => {
          if (plan.cartInfo.selected_number > get(maxPlan, 'cartInfo.selected_number', 0)) {
            return plan;
          }
          return maxPlan;
        }, {});
    },
    attendee() {
      return get(this.currentPlans, "[0].participants", 0);
    },
    trackingPlanName() {
       if (this.isEducationMeeting) {
        return this.$t(this.formPlan?.planNameKey);
      }
      else if (this.isSchool) {
        return translateToEn(this.formPlan?.planNameKey);
      }
      else {
        return this.$t(`Zoom One ${this.form?.category}`);
      }
    },
    hasAccountDiscount() {
      return get(this.basicConfig, 'hasAccountDiscount', false);
    },
    boughtMeetingPlan() {
      const boughtMeetingPlans = this.boughtPlans.filter(item => item.type === planTypes.ZOOM_MEETING);
      return boughtMeetingPlans.find(item => item.plan_code === this.currentEditOldPlanCode) || boughtMeetingPlans[0];
    },
    boughtLicense(){
      return get(this.boughtMeetingPlan, 'cartInfo.selected_number', 1);
    },
    bizHasNotStandardPriceUnlimitedAudioPlan() {
      return this.form.category === BASE_PLAN_SUB_TYPES.BIZ
        && this.boughtPlans.some(item => item.type === planTypes.TOLLFREE && item.category === AUDIO_SUB_TYPES.UNLIMITED && item.isStandardPrice === false);
    },
    isStandardPrice() {
      if (this.hasAccountDiscount) {
        return true;
      }
      return this.boughtMeetingPlan.isStandardPrice && !this.bizHasNotStandardPriceUnlimitedAudioPlan;
    },
    zmUnitedPlanQuantity() {
      return this.boughtPlans
        .filter(item => item.type === planTypes.ZOOM_UNITED)
        .reduce((pre, item) => item.cartInfo.selected_number + pre, 0);
    },
    zoneBundlePlanQuantity() {
      return this.boughtPlans
        .filter(item => item.type === planTypes.ZOOM_ONE_BUNDLE)
        .reduce((pre, item) => item.cartInfo.selected_number + pre, 0);
    },
    boughtMeetingLicense() {
      return get(this.boughtMeetingPlan, 'cartInfo.selected_number', 1);
    },
    downSellDisabled() {
      return this.basicConfig.downSellData && this.basicConfig.downSellData.disableDownSell;
    },
    minHostAndReason() {
      const boughtLicense = this.boughtMeetingLicense;
      if (this.downSellDisabled) {
        const reason = this.$t('billing.error.can_not_bought_plan_tips');
        // MRR >= 500 (direct account)
        return {
          minHost: boughtLicense,
          reason,
          popUpReason: reason,
          trackingType: EDIT_FLOW_TRACKING_TYPE.NOT_ABLE_TO,
        };
      } else if (!this.isStandardPrice) {
        const reason = this.$t('billing.planform.meeting_license_custom_pricing');

        // customized price
        return {
          minHost: this.isEducationMeeting ?
            Math.max(boughtLicense, this.boughtMeetingPlan.min) :
            boughtLicense,
          reason,
          popUpReason: reason,
          trackingType: EDIT_FLOW_TRACKING_TYPE.HAS_CUSTOMER_PRICING,
        }
      } else if (this.eligibleInfoForPromoCase?.min) { // promote campaign link (partner/marketing coupon)
        const reason = this.getDownsellDisabledReasonForPromotion({
          reason: this.eligibleInfoForPromoCase?.reason,
          boughtLicense,
        });
        return {
          minHost: boughtLicense,
          reason,
          popUpReason: reason,
          trackingType: EDIT_FLOW_TRACKING_TYPE.NOT_ABLE_TO,
        }
      }

      const meetingMin = get(this.formPlan, 'min', 1);
      const bundleLicense = this.zmUnitedPlanQuantity + this.zoneBundlePlanQuantity;
      const boughtMeetingPlans = this.boughtPlans.filter(item => item.type === planTypes.ZOOM_MEETING);
      let otherMeetingLicense = 0;
      if (boughtMeetingPlans.length > 1) {
        otherMeetingLicense = boughtMeetingPlans
          .filter(item => item.plan_code !== this.currentEditOldPlanCode)
          .reduce((sum, item) => sum + get(item, 'cartInfo.selected_number', 0), 0);
      }
      let minHost = Math.max(meetingMin - bundleLicense - otherMeetingLicense, 1);

      const maxLicenseAddonLicense = get(this.maxLicenseAddon, 'cartInfo.selected_number', 0);
      // Must ensure the sum of base is greater than or equal to addon's license, i.e., currentLicense + bundleLicense + otherMeetingLicense >= maxLicenseAddonLicense
      const serviceMinLicense = maxLicenseAddonLicense - bundleLicense - otherMeetingLicense;

      if (this.maxLicenseAddon && minHost < serviceMinLicense) {
        const maxLicenseAddonTypeNameKey = this.maxLicenseAddon.typeNameKey;
        const maxLicenseAddonTypeName = this.$t(maxLicenseAddonTypeNameKey);
        return {
          // If current purchased license is less than minimum, prevent decrease but allow increase
          minHost: Math.min(serviceMinLicense, boughtLicense),
          reason: this.$t('billing.meeting_license_decrease_tips_need_decrease_addon', { product: maxLicenseAddonTypeName }),
          popUpReason: this.$t('billing.licences_limit_tips', [maxLicenseAddonTypeName, this.$t('billing.planform.title.zoom_meeting_zoomonenew')]),
          trackingType: EDIT_FLOW_TRACKING_TYPE.KEEP_ADDON,
        }
      }
      // if edit biz and no biz plus plan, minHost >= ZOOM_MEETING_PRO_MIN_LICENSE
      const { plans } = this.getCurrentBasePlanInfo;
      if (plans?.[0]?.category === BASE_PLAN_SUB_TYPES.BIZ) {
        const { bundleLicenses } = this.plansofBizBundle;
        // only show when bundleLicenses > 0, which means user has been purchased biz+
        // if the current currency is not support biz+, we don't need to show this banner
        if (bundleLicenses > 0) {
          minHost = unlockBizLicenseCount ? 1 : Math.max(ZOOM_MEETING_PRO_MIN_LICENSE - this.zmUnitedPlanQuantity - bundleLicenses, 1);
          const reason = this.form.selectedNumber > 1 ? this.$t('billing.zobizplus.required_license_warning', [ZOOM_MEETING_PRO_MIN_LICENSE]) : '';
          return {
            minHost,
            reason,
            popUpReason: reason,
          }
        }
        // check biz plan
        const quantity = getMeetingPlanByCategory(this.boughtPlans)?.cartInfo?.selected_number ?? ZOOM_MEETING_PRO_MIN_LICENSE;
        minHost = quantity > ZOOM_MEETING_PRO_MIN_LICENSE ? ZOOM_MEETING_PRO_MIN_LICENSE : quantity;
      }
      // pro2biz
      if (this.migratePlanState.is.pro2biz) {
        minHost = Math.max(this.boughtMeetingPlan.cartInfo.selected_number, ZOOM_MEETING_PRO_MIN_LICENSE);
      }

      return {
        minHost: minHost,
        reason: '',
        popUpReason: '',
      };
    },
    minHost() {
      return this.minHostAndReason.minHost;
    },
    minHostReason() {
      return this.minHostAndReason.reason;
    },
    minHostPopUpReason() {
      return this.minHostAndReason.popUpReason;
    },
    cycleDisabledKeyAndReason() {
      const currentBillingCycles = this.currentFilterPlans.map(p => p.billing_cycle);

      const { isBulkLicenseAccount } = this.basicConfig;
      if (isBulkLicenseAccount) {
        return {
          key: this.form.billingCycle === BILLING_CYCLE.MONTHLY ? BILLING_CYCLE.ANNUAL : BILLING_CYCLE.MONTHLY,
          keys: currentBillingCycles.filter(billingCycle => billingCycle !== this.form.billingCycle),
          reason: this.$t('billing.error.buld_acount_license'),
        };
      }

      if (this.disableMonthly2AnnualTip && !this.isMultipleCoupon) {
        return {
          key: BILLING_CYCLE.ANNUAL,
          keys: currentBillingCycles.filter(billingCycle => billingCycle !== this.form.billingCycle),
          reason: this.disableMonthly2AnnualTip,
        }
      }

      if (this.cycleDisabledKeyAndReasonForPartner) {
        return this.cycleDisabledKeyAndReasonForPartner;
      }

      if (this.eligibleInfoForPromoCase?.key) {
        return this.eligibleInfoForPromoCase;
      }

      const planGroupByType = groupBy(this.limitCycleAddonPlans, 'type');
      const typeNames = Object.keys(planGroupByType).map(type => {
        const typeNameKey = get(planGroupByType[type], '0.typeNameKey', '');
        return this.$t(typeNameKey);
      }).filter(Boolean);
      const hasMonthlyMeeting = this.boughtMeetingPlans.some(item => item.billing_cycle === BILLING_CYCLE.MONTHLY);
      if (this.limitCycleAddonPlans.length && !hasMonthlyMeeting) {
        const disablePlan = this.currentPlans.find((p) => p.cycleValue < this.boughtMeetingPlan.cycleValue);
        return {
          key: disablePlan.billing_cycle,
          reason: this.$t('billing.planform.can_not_select_with_special_addon', [
            this.$t('billing.planform.title.zoom_meeting_zoomonenew'),
            typeNames.join(','),
            this.$t(`billing.billing_cycle.${disablePlan.billing_cycle}`)?.toLowerCase(),
          ]),
        };
      }
      return {};
    },
    canSwitchCategory() {
      const hasBundle = !!(this.zmUnitedPlanQuantity + this.zoneBundlePlanQuantity);
      return !hasBundle;
    },
    assignedMeetingInfo() {
      const boughtMeetingCode = get(this.boughtMeetingPlan, 'plan_code', '');
      return this.assignInfo[boughtMeetingCode];
    },
    needUnAssignTips() {
      return validDownSellLicense({ quantity: this.form.selectedNumber })?.errorMessage;
    },
    mx_decreaseTips() {
      if (this.needUnAssignTips) {
        return this.needUnAssignTips;
      }
      if (this.form.selectedNumber <= this.minHost) {

        if (this.$context.is.mixBuy) {
          return this.minHostPopUpReason;
        }

        return this.minHostReason;
      }
      return '';
    },
    popUpDecreaseTips() {
      if (this.$context.is.mixBuy) return this.mx_decreaseTips;
      return "";
    },
    licenseTips() {
      if (this.$context.is.mixBuy) return "";
      return this.mx_decreaseTips;
    },
    cartMeetingPlan() {
      return this.getSelectedPlans.find((item) => item.type === planTypes.ZOOM_MEETING);
    },
    cycleDisabledKeyAndReasonForPartner() {
      return this.getCycleDisabledKeyAndReasonForPartner();
    },
    maxHostInfo() {
      if (this.form.category === ZOOM_MEETING_SUB_TYPES.PRO) {
        return {
          max: this.boughtLicense + 99,
          tips: this.$t('billing.error.cant_add_100')
        }
      }
      return {
        max: 9999,
        tips: ''
      }
    },
    maxHost() {
      if (!this.canExpand && this.updateBasePlan?.autoAdd) {
        return DEFAULT_MAX_HOST;
      }
      return this.maxHostInfo.max;
    },
    increaseTips() {
      if (this.form.selectedNumber >= this.maxHostInfo.max) {
        return this.maxHostInfo.tips;
      }
      return '';
    },
    isSchool() {
      return this.form?.category === ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP
    },
    showUnlockBizCountTip() {
      return isInUnlockBizCountRetentionFlow() && this.minHost < 10
    },
    headClassForSchool() {
      if (this.isSchool) {
        return this.isExpanded ? ['opc-zm-base-card__head-right__for_school--expand'] : ['opc-zm-base-card__head-right__for_school--collapse'];
      }
      return [];
    },
    classForSimplifySubscriptionCycle() {
      return this.mxIsSimplifyForProEdit ? [...this.mxClassForSimplify, 'zbo-form-item__opc-simplify'] : [];
    }
  },
  created() {
    this.updateForm(true);
    ZoomMeetingDialogUtils.install(this.formPlan);
  },
  mounted() {
    this.$context.$on('collapse-plan-card', this.collapseCard);
    const isSpecialBillingCycle = ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(this.boughtMeetingPlan?.billing_cycle);
    const isMultipleRatePlans = this.boughtMeetingPlan?.ratePlans?.length > 1;
    if(this.isEducationMeeting && this.$config('enableEduAnnualUpgrade') && !this.$context.is.edu2esc && !isSpecialBillingCycle && !isMultipleRatePlans){
      const link = '/opc/buy/config?plan=zoneduschcmp&period=annual&from=zoneduschcmp&type=edu2esc';
      $info({ message: this.$t('billing.zone.edu.alert_title', [updateHrefWithQueryParams(link, MODAL_QUERY_PARAMS)]) ,className:'reason-tips'});
    }
  },
  methods: {
    getPlanCollapseText() {
      return getPlanCollapseText({
        amount: this.formPlan?.amount,
        billingCycle: this.form.billingCycle,
        quantity: this.form.selectedNumber,
        cycleValue: this.formPlan?.cycleValue,
        unit: this.formPlan?.unit,
      });
    },
    showSaveCount(plan) {
      return this.mxIsSimplifyForProEdit &&
        plan.billing_cycle === BILLING_CYCLE.ANNUAL &&
        this.currentEditPlan?.billing_cycle !== BILLING_CYCLE.ANNUAL;
    },
    getBilledText(plan) {
      return this.mxIsSimplifyForProEdit ?
        this.ariaPriceOfMonthForLabel(plan) + this.getMergedBilledText(plan.billing_cycle, plan.amount) :
        this.getMergedBilledText(plan.billing_cycle, plan.amount)
    },
    getBillingCycleText(billingCycle) {
      let text = this.$t(`billing.billing_cycle.${billingCycle}`);
      if (this.mxIsSimplifyForProEdit && billingCycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY) {
        text = `${text}, ${this.$t('billing.bill_monthly')}*`;
      }
      return text;
    },
    getCurrentBilledText() {
      const bounghtBillingCycle = this.boughtMeetingPlan.billing_cycle;
      if (bounghtBillingCycle === BILLING_CYCLE.MONTHLY) {
        return this.$t('billing.simplify.current_billed_monthly');
      } else if (bounghtBillingCycle === BILLING_CYCLE.ANNUAL) {
        return this.$t('billing.simplify.current_billed_annually');
      } else {
        return ''
      }
    },
    BillingCycleEnum() {
      return BillingCycleEnum
    },
    ...mapActions({
      switchSelectPlan: 'switchSelectPlan',
    }),
    ...mapMutations(['updateSelectPlan', 'savePersist', 'setUpdateBasePlan']),
    // sync shopping cart plan to local form state
    updateForm(isInitUpdateForm = false) {
      // pre check from params
      const shoppingCartPlan = this.getSelectedPlans.find((item) => item.type === planTypes.ZOOM_MEETING);
      if (shoppingCartPlan) {
        this.form.category = shoppingCartPlan.category;
        this.form.billingCycle = shoppingCartPlan.billing_cycle;
        this.form.selectedNumber = shoppingCartPlan.cartInfo.selected_number;
        this.oldPlanCode = shoppingCartPlan.plan_code;
      }

      this.isInitUpdateForm = isInitUpdateForm;
    },
    submitForm: throttle(function (v) {
      this.$nextTick(() => {
        if (!this.formPlan) {
          return;
        }

        if (isEmptyVal(v)) {
          this.form.selectedNumber = Math.max(this.formPlan?.cartInfo?.selected_number ?? 0, this.minHost);
        }

        if (this.formPlan.plan_code === this.oldPlanCode) {
          this.updateSelectPlan({
            ...this.formPlan,
            cartInfo: {
              selected_number: this.form.selectedNumber,
            },
          });
        } else {
          this.switchSelectPlan([
            this.oldPlanCode,
            this.formPlan.plan_code,
            {
              selected_number: this.form.selectedNumber,
            },
          ]);
        }
        this.updateForm();
      });
    }, 200),
    async handleExploreOtherPlansClick() {
      this.$tracking.buyInteraction('explore other plans', `${this.trackingPlanName} - explore other plans`);
      this.$context.$emit('change-tile-status', false);
      await this.showFullComparisonDialog();
    },
    async handlePlanDetailsClick() {
      if (this.isEducationMeeting) {
        this.$tracking.buyInteraction('plan details selected', this.trackingPlanName);
        if(this.$config('enableEduAnnualUpgrade')) return await this.showFullComparisonDialog();
      }
      await ZoomMeetingDialogUtils.showPlanDetail({ planCategory: this.formPlan.category });
    },
    handleSelectNumOfUsersTipsClick() {
      if (this.isEducationMeeting) {
        this.$tracking.buyInteraction(`${this.trackingPlanName} options`, 'number of licenses - tooltip');
      } else {
        this.$tracking.buyInteraction(`${this.trackingPlanName} options`, 'number of users - tooltip')
      }
    },
    async showFullComparisonDialog() {
      this.$tracking.buyInteraction('product details', 'full plan comparison - impression');
      await ZoomMeetingDialogUtils.showComparisonDialog({
        planCategory: this.formPlan.category,
        largeMeetingConfig: {
          school: {
            callback: () => {},
            disabled: true,
            display: false
          },
          schoolPlus: {
            callback: () => {},
            disabled: true,
            display: false
          },
        }
      });
      this.$nextTick(() => this.updateForm());
    },
    getCategoryName(category) {
      return this.$t(getCategoryNameI18nKey(category));
    },
    updateCollapsedPlan(from) {
      this.updateForm();
      this.alertTitle = this.$t('billing.zone.alert_title', [from, this.$t(this.boughtMeetingPlan?.planNameKey)])
      this.canExpand = false;
      this.isExpanded = false;
      this.setUpdateBasePlan({ ...this.updateBasePlan, update: false, from: '' });
      this.showFoldable = false;
      this.$nextTick(() => {
        this.showFoldable = true; // Avoid the appearance of the collapse animation.
      })
    },
    onLicenseTipsClick(event) {
      if (this.isSchool && event.target.tagName?.toUpperCase() === 'A') {
        this.$tracking.buyInteraction('banner - product level', `${this.trackingPlanName} - ${event.currentTarget.textContent} - ${event.target.textContent}`)
      }

      if (event?.target?.tagName === A_LINK_TAG_NAME && event?.target?.textContent === A_LINK_TEXT_CONTENT.FORM) {
        this.$tracking.buyInteraction(
          'banner - product level',
          `${this.trackingPlanName} - 'you are not able to make this change to  your account mid-contract' - contact form`);
        return;
      }
      this.doReturnPlanManagementTracking(event, 'adjust the add-on product and base product license quantity');
    },
    onCycleClick(event) {
      this.doReturnPlanManagementTracking(event, 'update to monthly subscription first');
    },
    doReturnPlanManagementTracking(event, msg) {
      if (event?.target?.tagName === A_LINK_TAG_NAME && event?.target?.textContent === A_LINK_TEXT_CONTENT.RETURN_PLAN_MANAGEMENT) {
        this.$tracking.buyInteraction(
          'banner - product level',
          `${this.trackingPlanName} - ${msg} - return to plan management`);
      }
    },
    getPlanUnitWithCycle(cycle) {
      return getPlanUnitWithCycle(cycle);
    },
    billingCycleDisabled({ billing_cycle, disabled }) {
      if (this.boughtMeetingPlans.length > 1) {
        return ![BILLING_CYCLE.ANNUAL, BILLING_CYCLE.MONTHLY].includes(billing_cycle);
      }
      if (Array.isArray(this.cycleDisabledKeyAndReason.keys)) {
        return this.cycleDisabledKeyAndReason.keys.includes(billing_cycle) || disabled;
      }
      return this.cycleDisabledKeyAndReason.key === billing_cycle || disabled;
    },
    collapseCard() {
      this.isExpanded = false;
    }
  },
  components: {
    Foldable,
    Tile,
    InputNumberWithPopover,
    PreviewPayment,
    BoughtLicense,
    CycleCurrentBadge,
    SaveCount,
    UserChanges,
    SubscriptionCycleSubTitle,
    PriceBillTextTips,
    MultipleMeetingSingleEditForm,
  },
  watch: {
    'eligibleInfoForPromoCase.min': {
      immediate: true,
      handler(val) {
        if (val && this.form.selectedNumber < this.boughtMeetingLicense) {
          this.submitForm();
        }
      }
    },
    isExpanded: {
      handler(val) {
        this.$tracking.buyInteraction(
          'product details accordion',
          `${this.trackingPlanName} - ${val ? 'expand' : 'collapse'}`,
        );
      },
    },
    'form.billingCycle': {
      immediate: true,
      handler: debounce(function (val) {
        !this.isInitUpdateForm && this.$tracking.buyInteraction(
          'billing cycle',
          `${this.trackingPlanName} - toggled billed ${val}`,
        );
        if (val !== this.cycleDisabledKeyAndReason.key && this.cycleDisabledKeyAndReason.reason) {
          this.$tracking.buyInteraction(
            'banner - product level',
            `${this.trackingPlanName} - update to monthly subscription first - impression`);
        }

        if (this.isSchool) {
          this.$tracking.buyInteraction('subscription cycle', `${this.trackingPlanName} - ${val}`)
        }
      }, 500),
    },
    'form.selectedNumber': {
      handler: debounce(function (newLicense, oldLicense) {
        let _newLicense = newLicense;
        if (this.$context.is.delta) _newLicense = this.deltaForm?.selectedNumber;
        if (this.formPlan && !this.isInitUpdateForm) {
          // event tracking
          if (this.isEducationMeeting) {
            this.$tracking.buyInteraction('number of licenses', `${this.trackingPlanName} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${_newLicense}`);
          } else {
            this.$tracking.buyInteraction(this.isSchool ? 'number of users' : 'number of hosts', `${this.trackingPlanName} - ${newLicense > oldLicense ? 'increase' : 'decrease'} - ${_newLicense}`);
          }
        }
      }, 500),
    },
    updateBasePlan: {
      handler(val) {
        val?.update && this.updateCollapsedPlan(val?.from);
      },
    },
    licenseTips: {
      handler(val) {
        if (val) {
          if (this.isSchool) {
            this.$tracking.buyInteraction(`banner - product level`, `${this.trackingPlanName} - ${val.replace(/(<([^>]+)>)/ig, '')} - impression`)
          }

          if (this.form.selectedNumber <= this.minHost) {
            if (this.minHostAndReason?.trackingType) {
              switch (this.minHostAndReason.trackingType) {
                case EDIT_FLOW_TRACKING_TYPE.NOT_ABLE_TO:
                  this.$tracking.buyInteraction(
                    'banner - product level',
                    `${this.trackingPlanName} - you are not able to make this change to  your account mid-contract - impression`);
                  break;
                case EDIT_FLOW_TRACKING_TYPE.HAS_CUSTOMER_PRICING:
                  this.$tracking.buyInteraction(
                    'banner - product level',
                    `${this.trackingPlanName} - your account has custom pricing - impression`);
                  break;
                case EDIT_FLOW_TRACKING_TYPE.KEEP_ADDON:
                  this.$tracking.buyInteraction(
                    'banner - product level',
                    `${this.trackingPlanName} - adjust the add-on product and base product license quantity - impression`);
              }
            }
          }
        }
      },
    },
    cartMeetingPlan: {
      deep: true,
      handler() {
        this.updateForm();
      },
    },
    maxHost(val) {
      if (this.form.selectedNumber > val) {
        this.form.selectedNumber = val
        this.submitForm(val)
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@/styles/zoom-card.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/scss-utils.scss';

.opc-zmone {
  .main-icon {
    color: $theme-color;
  }

  .reason-tips {
    margin-top: 12px;

    p {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    }
  }

  &__link.zbo-button--text {
    font-weight: 700 !important;
    color: $theme-color;
    padding: 0;
  }

  &__quantity-selector {
    margin-top: 8px;
    @include media(mobile) {
      margin-top: 8px;
    }
    @include simplifyStyle() {
      margin: 0;
    }
  }

  &__desc {
    padding-bottom: 20px;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
  }

  &__main {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #dfdfe4;
    @include simplifyStyle() {
      margin-top: 20px;
      padding-top: 20px;
      .opc-config-form {
        padding: 0;
        .zbo-form-item {
          margin-bottom: 0;
          .zbo-form-item__content {
            display: flex;
            margin-bottom: 20px;
            flex-wrap: wrap;
            .opc-zmone__form-label,
            .opc-zmone__quantity-selector-container {
              flex: 1;
              margin: 0;
            }
            .reason-tips {
              flex-basis: 100%;
            }
            .opc-zmone__form-label {
              font-size: 16px;
              font-weight: 600;
              line-height: 150%;
            }
          }
          &.zbo-form-item__opc-simplify {
            border-top: 1px solid #dfdfe4;
            padding-top: 20px;
            margin-bottom: 0;
            display: flex;
            .zbo-form-item__header,
            .zbo-form-item__content {
              flex: 1;
              margin: 0;
            }
          }
        }
        .opc-card-radio {
          flex-direction: column;
          margin: 0;
          gap: 8px;
          .zbo-radio {
            &__inner {
              position: relative;
              left: unset;
              right: unset;
              width: 16px;
              height: 16px;
              border: 1px solid var(--zoom-color-border-neutral, #98A0A9);
            }
            &__wrap {
              &.is-checked::after {
                display: none;
              }
              &--inner {
                height: auto;
                padding: 0;
                border: none;
                min-width: auto;
              }
              &.is-checked {
                .zbo-radio__label--inner {
                  border: none;
                }

                .zbo-radio__inner {
                  border-color: #0D6BDE;
                  background-color: #0D6BDE !important;
                }
              }
              &.is-focus {
                .zbo-radio__label--inner {
                  .is-keyboard-event & {
                      box-shadow: none;
                  }
                }
              }
              &:not(.is-disabled) {
                &:hover {
                  .zbo-radio__label--inner {
                      background: none;
                  }
                }
              }
            }
          }
          .opc-zmone__radio {
            &-title {
              color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: 18px;
              margin-bottom: 4px;
            }
          }
        }
      }
    }

    @include media(mobile) {
      margin-top: 16px;
      padding-top: 16px;
    }
  }

  &__desc {
    position: relative;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: var(--zoom-color-text-strong-neutral, #555B62);
    padding: 0;
    margin: 0;

    &.is-warning {
      padding: 8px 12px 8px 40px;
      background: var(--zoom-color-fill-subtler-warning, #FFF9F2);
      border-radius: 8px;

      &::before {
        content: '';
        background-image: url('../../../assets/Alert.svg');
        width: 16px;
        height: 16px;
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: calc(50% - 8px);
        left: 12px;
      }
    }
  }

  &__form-label {
    margin: 0;
    padding: 0;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 16px;
    font-weight: 600;
    line-height: 20px; /* 125% */
    letter-spacing: -0.31px;
    @include media(mobile) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  .opc-card-radio {
    margin-top: 8px;

    .opc-zmone__radio {
      .zbo-radio__wrap {
        width: 100%;
      }
    }
  }

  .opc-card-radio &__radio {
    &.compact {
      .zbo-radio__label--inner {
        padding: 12px;
      }
    }
    .zbo-radio__label--inner {
      width: 100%;
      // min-height: 136px;
      padding: 16px;
    }

    .zbo-radio__label {
      &.is-disabled {
        .opc-zmone__radio-title,
        .opc-zmone__radio-price,
        .opc-zmone__radio-price-unit,
        .opc-zmone__radio-title-billed-text {
          color: var(--zoom-color-state-disable, #ADB1B8) !important;
        }
      }
    }

    &-title {
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px;
      margin: 0;

      .opc-price-save-count {
        margin-left: 4px;
      }
    }

    &-save-label {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 21px;
      color: var(--zoom-color-text-success, #247F40);
      min-width: 1px;
      min-height: 21px;
    }

    &-price {
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      font-size: 24px;
      font-style: normal;
      font-weight: 590;
      line-height: 28px;

      &-unit {
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
      }

      &-delete {
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        text-decoration-line: line-through;
        color: var(--zoom-color-text-strong-neutral, #555B62);
      }
    }
  }
  .opc-plan__bought-license {
    padding: 8px 0px 0px;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.8px;
    text-align: left;
    color: var(--zoom-color-text-neutral, #686F79);
  }

}

.opc-zm-base-card__view-detail-button {
  @include simplifyStyle() {
    flex-shrink: 0;
    .zbo-button.zbo-button--text {
      font-weight: 500 !important;
    }
  }
}

.opc-plan__billing-text {
  color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

/* simplify */
.opc-simplify {
  .opc-zmone__main .opc-config-form {
    .zbo-form-item.opc-zmone__form-item--license {
      &.zbo-form-item {
        margin-bottom: 20px;
      }

      .zbo-form-item__row {
        width: 100%;
      }

      .zbo-form-item__widgets {
        display: flex;

        .opc-zmone__form-label {
          font-size: 16px;
          font-weight: 600;
          line-height: 150%;
          flex: 1;
        }

        .opc-zmone__quantity-selector-container {
          flex: 1;
        }
      }
    }
  }

  .zbo-form-item__opc-simplify {
    &.zbo-form-item {
      .zbo-form-item__row {
        display: flex;
        align-items: flex-start;
        width: 100%;

        .zbo-form-item__label-wrapper, .zbo-form-item__widgets {
          flex: 1;
        }

        .opc-card-radio {
          .opc-zmone__radio {
            .zbo-radio__wrap {
              align-items: flex-start;
              border: none;
              padding: 0px !important;

              &.is-checked {
                border: none;
                &:after {
                  display: none;
                }
              }
            }

            .zbo-radio__label {
              padding: 0px;
              border: none !important;
              background: none !important;
            }
          }
        }
      }
    }
  }
}

.opc-zmone__form-item--license {
  .zbo-form-item__row {
    .zbo-form-item__label-wrapper {
      height: 0px;
    }
  }
}
</style>

<style lang="scss">
.opc-zone__tip b {
  font-weight: bold !important;
}
.bottom-msg-row {
  margin-top: 16px;
}
.opc-zmone--delta .zbo-form-item.opc-config-form__last-item .zbo-form-item__row .zbo-radio__wrap.is-checked {
  border:transparent !important;
}
</style>
